import { gql } from '@apollo/client';
import type IEmployeeTalkTemplate from '@sharedInterfaces/IEmployeeTalkTemplate';

import GraphQL from '../graphQL';

interface EmployeeTalkTemplateResult {
    employeeTalkTemplate: IEmployeeTalkTemplate | null;
}

const GET_EMPLOYEE_TALK_TEMPLATE = gql`
  query GetEmployeeTalkTemplate($id: ID!) {
    employeeTalkTemplate(id: $id) {
      id
      title
      description
      templateVersion
      pages {
        id
        title
        order
        sections {
          id
          title
          order
          columns {
            id
            components {
              id
              type
              label
              description
              required
              order
              properties
            }
          }
        }
      }
      isActive
      createdAt
      changedAt
    }
  }
`;

export async function getEmployeeTalkTemplate(id: string): Promise<IEmployeeTalkTemplate | null> {
    return GraphQL.query<EmployeeTalkTemplateResult>(GET_EMPLOYEE_TALK_TEMPLATE, { id })
        .then((t) => t.employeeTalkTemplate)
        .then((t) => {
            if (!t) return null;
            switch (typeof t.id) {
                case 'string':
                    t.id = Number.parseInt(t.id);
                    break;
            }
            return t;
        });
}
